import {EstateCard, EstateCardProps, EstateCardViewModeType} from "../../EstateCard/EstateCard";
import React from "react";

export type NonTrustDistributionsLayerProps = {
    estateCardProps: EstateCardProps[],
    viewMode: EstateCardViewModeType,
    selectedCardId?: string,
    selectedCardRef?: React.RefObject<HTMLDivElement>
}

const NonTrustDistributionsLayer = ({
                                        estateCardProps,
                                        viewMode,
                                        selectedCardId,
                                        selectedCardRef
                                    }: NonTrustDistributionsLayerProps) => {
    return <div className={`non-trust-distributions-layer ${viewMode}-view-grid-gap`} data-testid={"non-trust-distributions-layer"}>
        {
            estateCardProps.map((estateCard) => (
                <EstateCard key={`estate-card-${estateCard.estateItem.title}-${estateCard.estateItem.id}}`}
                            viewMode={estateCard.viewMode}
                            estateItem={estateCard.estateItem}
                            isCardSelected={selectedCardId === estateCard.estateItem.id}
                            selectedCardRef={selectedCardRef}
                />
            ))
        }
    </div>;
}

export default NonTrustDistributionsLayer;